function NoMatch(props) {
    return (
        <div className="alert alert-danger" role="alert">
            <h2 className="text-center mb-0">Invalid URL.</h2>
        </div>
    );
}

export default NoMatch;
